import { render, staticRenderFns } from "./PersonalSetting.vue?vue&type=template&id=0af071c4&scoped=true&"
import script from "./PersonalSetting.vue?vue&type=script&lang=js&"
export * from "./PersonalSetting.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSetting.vue?vue&type=style&index=0&id=0af071c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af071c4",
  null
  
)

export default component.exports